export interface ImageBounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function calculateContainedImageBounds(
  naturalWidth: number,
  naturalHeight: number,
  containerWidth: number,
  containerHeight: number
): ImageBounds {
  if (
    naturalWidth <= 0 ||
    naturalHeight <= 0 ||
    containerWidth <= 0 ||
    containerHeight <= 0
  ) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  const imageAspect = naturalWidth / naturalHeight;
  const containerAspect = containerWidth / containerHeight;

  if (imageAspect > containerAspect) {
    const width = containerWidth;
    const height = containerWidth / imageAspect;

    return {
      x: 0,
      y: (containerHeight - height) * 0.5,
      width,
      height,
    };
  }

  const height = containerHeight;
  const width = containerHeight * imageAspect;

  return {
    x: (containerWidth - width) * 0.5,
    y: 0,
    width,
    height,
  };
}
